const paymentPlans = state => state.paymentPlans;

const paymentPlansLoading = state => state.paymentPlansLoading;

const paymentHistory = state => state.paymentHistory;

const paymentHistoryLoading = state => state.paymentHistoryLoading;

const paymentHistories = state => state.paymentHistories;

const paymentHistoriesLoading = state => state.paymentHistoriesLoading;

const payment = state => state.payment;

const paymentLoading = state => state.paymentLoading;

const promoCode = state => state.promoCode;

const promoCodeLoading = state => state.promoCodeLoading;

const promoCodeValidation = state => state.promoCodeValidation;

const initializePayment = state => state.initializePayment

export default {
  paymentPlans,
  paymentPlansLoading,
  paymentHistories,
  paymentHistoriesLoading,
  paymentHistory,
  paymentHistoryLoading,
  payment,
  paymentLoading,
  promoCode,
  promoCodeLoading,
  promoCodeValidation,
  initializePayment
};
